module.exports = __webpack_public_path__ + "static/logo5-9a04e3146b3b27ba1d966391fba6f30e.png";